import { useStableCallback } from "@business-finland/wif-ui-lib";
import { useCallback } from "react";

import useMutation from "../../../hooks/useMutation";
import { CompanyFormSubmitError } from "../../../util/companies-utils";
import { type CompanyFormDispatch, companyFormActions } from "./store";

const companyLogoFieldName = "companyLogo";

export default function useSubmit(dispatch: CompanyFormDispatch) {
  const { mutate } = useMutation<CompanyIdValidationResponse | string>(
    "/api/companies/form-submit/",
    {
      onLoading: useStableCallback(() =>
        dispatch(companyFormActions.startLoading())
      ),
      onSuccess: useStableCallback((data) => {
        if (data && typeof data === "string" && data !== "OK") {
          return dispatch(
            companyFormActions.setErrorMessage(data as CompanyFormSubmitError)
          );
        } else {
          dispatch(companyFormActions.submit());
        }
      }),
      onError: useStableCallback(() => {
        dispatch(companyFormActions.stopLoading());
      }),
    }
  );

  return useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);

      const logoFile = formData.get(companyLogoFieldName);
      if (logoFile instanceof File && logoFile.size === 0) {
        formData.delete(companyLogoFieldName);
      }

      mutate({ method: "POST", body: formData });
    },
    [mutate]
  );
}

type CompanyIdValidationResponse = {
  companyId: string;
  valid: boolean;
};
